export default IconTargetOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-target-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M11.286 11.3a1 1 0 0 0 1.41 1.419" />
  <path d="M8.44 8.49a5 5 0 0 0 7.098 7.044m1.377 -2.611a5 5 0 0 0 -5.846 -5.836" />
  <path d="M5.649 5.623a9 9 0 1 0 12.698 12.758m1.683 -2.313a9 9 0 0 0 -12.076 -12.11" />
  <path d="M3 3l18 18" />
</svg>`;